<section class="deal-page">
    <div class="add-deal-doc">
        <div class="left-actions">
            <button (click)="reloadPage()" mat-button class="refresh" data-test="deals-internal-refresh"><mat-icon>refresh</mat-icon> Refresh Page</button>
        </div>
        <div class="right-actions">
            <button
                *ngIf="isDesktop && !hasCoBuyer && !isArchived && !isDeleted"
                mat-button
                class="standard secondary"
                (click)="addCoBuyer()"
                data-test="deal-add-cobuyer"
            >
                Add Co-Buyer
            </button>

            <ng-container *ngIf="isDesktop && hasCoBuyer && isOpened">
                <span [matTooltip]="'Swap Buyer and Co-Buyer'">
                    <button class="secondary" mat-button (click)="swapBuyerAndCoBuyer()" data-test="deals-swap-buyer-cobuyer-button">
                        Swap Buyer & Co-Buyer
                    </button>
                </span>
            </ng-container>

            <button
                *ngIf="showArchive() && deal.statusId === dealType.Archived"
                mat-button
                class="standard primary"
                (click)="archiveDeal(deal.statusId !== dealType.Archived)"
                [class.disabled]="!canArchive(true)"
                [disabled]="!canArchive(true)"
                data-test="deals-archive-or-unarchive-deal"
            >
                Unarchive Deal
            </button>

            <div
                *ngIf="isDesktop && !isArchived && isInternalUser"
                class="right-actions route-one-hoover"
                matTooltip="You are currently not enrolled in this feature. Contact us at {{ tenantSupportPhone }} to learn more."
                [matTooltipDisabled]="routeOneEnabled()"
            >
                <button
                    *ngIf="!isDeleted"
                    mat-button
                    class="standard secondary"
                    (click)="getRIC()"
                    [disabled]="!routeOneEnabled()"
                    [matTooltip]="getR1MessageForSyncButton"
                    data-test="deals-sync-with-e-contract"
                >
                    Sync With E-Contract
                </button>
                <button
                    *ngIf="!isDeleted"
                    mat-button
                    class="standard secondary"
                    (click)="goToSendDocuments('route-one')"
                    [disabled]="!routeOneEnabled()"
                    [matTooltip]="getR1MessageForUploadButton"
                    data-test="deals-upload-docs-to-e-contract"
                >
                    Upload Docs to E-Contract
                </button>
            </div>
            <div *ngIf="isDesktop && canModifyDocuments(true)">
                <button
                    mat-button
                    class="standard secondary"
                    [routerLink]="['/dashboard', 'deals', deal.dealId, 'add', 'multiple']"
                    [disabled]="!canModifyDocuments(true)"
                    matTooltip="Click Here to Add Documents to this Deal Jacket"
                    data-test="deals-upload-documents"
                >
                    Upload Documents
                </button>
            </div>
            <button
                *ngIf="isOpened || isClosed"
                mat-button
                class="standard primary"
                (click)="addFandIForm()"
                [disabled]="!canModifyDocuments"
                data-test="deals-add-f-and-i-form"
            >
                Add F&I Form
            </button>
            <button
                *ngIf="isDeleted"
                mat-button
                class="standard primary"
                [class.disabled]="!canRestore"
                [disabled]="!canRestore"
                (click)="restoreDeal()"
                data-test="deals-restore-deal"
            >
                Restore Deal Jacket
            </button>

            <button
                *ngIf="!isDeleted"
                mat-icon-button
                class="additional-actions-button"
                [matMenuTriggerFor]="actionsMenu"
                aria-label="Additional actions for the deal jacket."
                data-test="deals-elipsis-expander"
            >
                <mat-icon class="vert-icon">more_vert</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                <button
                    *ngIf="!isDesktop && !hasCoBuyer && !isArchived && !isDeleted"
                    class="standard secondary"
                    (click)="addCoBuyer()"
                    data-test="deal-add-cobuyer"
                    mat-menu-item
                >
                    Add Co-Buyer
                </button>

                <ng-container *ngIf="!isDesktop && hasCoBuyer && isOpened">
                    <span [matTooltip]="'Swap Buyer and Co-Buyer'">
                        <button class="secondary" (click)="swapBuyerAndCoBuyer()" data-test="deals-swap-buyer-cobuyer-button" mat-menu-item>
                            Swap Buyer & Co-Buyer
                        </button>
                    </span>
                </ng-container>

                <div
                    *ngIf="!isDesktop && !isArchived && isInternalUser"
                    class="right-actions route-one-hoover"
                    matTooltip="You are currently not enrolled in this feature. Contact us at {{ tenantSupportPhone }} to learn more."
                    [matTooltipDisabled]="routeOneEnabled()"
                >
                    <button
                        class="standard secondary"
                        (click)="getRIC()"
                        [disabled]="!routeOneEnabled()"
                        [matTooltip]="getR1MessageForSyncButton"
                        data-test="deals-sync-with-e-contract"
                        mat-menu-item
                    >
                        Sync With E-Contract
                    </button>
                    <button
                        class="standard secondary"
                        (click)="goToSendDocuments('route-one')"
                        [disabled]="!routeOneEnabled()"
                        [matTooltip]="getR1MessageForUploadButton"
                        data-test="deals-upload-docs-to-e-contract"
                        mat-menu-item
                    >
                        Upload Docs to E-Contract
                    </button>
                </div>
                <div *ngIf="!isDesktop && canModifyDocuments(true)">
                    <button
                        class="standard secondary"
                        [routerLink]="['/dashboard', 'deals', deal.dealId, 'add', 'multiple']"
                        [disabled]="!canModifyDocuments(true)"
                        matTooltip="Click Here to Add Documents to this Deal Jacket"
                        data-test="deals-upload-documents"
                        mat-menu-item
                    >
                        Upload Documents
                    </button>
                </div>
                <div *ngIf="canDownloadDocuments">
                    <button
                        mat-menu-item
                        [ngClass]="!canDownloadDocuments ? 'disabled' : 'download'"
                        [disabled]="!canDownloadDocuments"
                        (click)="downloadDocuments()"
                        data-test="deals-download-documents"
                    >
                        Download Documents
                    </button>
                </div>
                <button *ngIf="deal.statusId !== dealType.Archived" mat-menu-item (click)="mergeDocuments()" data-test="deals-merge-documents">
                    Merge Documents
                </button>
                <button
                    *ngIf="isInternalUser"
                    [disabled]="!canAccessNotarization"
                    [matTooltip]="
                        !canAccessNotarization
                            ? 'You are currently not enrolled in this feature. Contact us at ' + tenantSupportPhone + ' to learn more.'
                            : 'Notarize Documents'
                    "
                    matTooltipPosition="left"
                    mat-menu-item
                    (click)="notarizeDocuments()"
                    data-test="deals-notarize-documents"
                >
                    Notarize Documents
                </button>

                <button mat-menu-item data-test="delete-documents" (click)="openDeleteDocumentsModal()">Delete Documents</button>

                <div *ngIf="canArchive(true) && deal.statusId !== dealType.Archived">
                    <button
                        *ngIf="showArchive()"
                        mat-menu-item
                        (click)="archiveDeal(deal.statusId !== dealType.Archived)"
                        [class.disabled]="!canArchive(true)"
                        [disabled]="!canArchive(true)"
                        data-test="deals-archive-or-unarchive-deal"
                    >
                        Archive Deal
                    </button>
                </div>
                <div *ngIf="canReopen()">
                    <button mat-menu-item (click)="reopenDeal()" data-test="deals-reopen-deal">Reopen Deal</button>
                </div>
                <div *ngIf="canClose(true)">
                    <button
                        *ngIf="deal.statusId === dealType.Open || deal.statusId === dealType.Archived"
                        mat-menu-item
                        (click)="closeDeal()"
                        [class.disabled]="!canClose(true)"
                        [disabled]="!canClose(true)"
                        data-test="deals-close-deal"
                    >
                        Close Deal
                    </button>
                </div>
                <div *ngIf="canDeleteDeal(true)">
                    <button
                        mat-menu-item
                        class="delete"
                        [class.disabled]="!canDeleteDeal(true)"
                        [disabled]="!canDeleteDeal(true)"
                        (click)="dealDelete()"
                        data-test="deals-delete-deal"
                    >
                        Delete Deal
                    </button>
                </div>
            </mat-menu>
        </div>
    </div>
    <div class="content-wrap">
        <div class="documents-wrap">
            <!-- DEALER -->
            <div class="card" data-test="deals-dealer-queue-card">
                <h2 data-test="deals-dealer-queue-card-title">
                    <span>Documents Waiting For Dealer ({{ dealDocs.dealer.length }})</span>
                </h2>

                <ng-container *ngIf="dealDocs.dealer.length > 0; else noDealerDocs">
                    <div class="document-container" data-test="deals-dealer-queue-docs-list" [ngClass]="dealDocs.dealer.length <= 3 ? 'left' : 'center'">
                        <button
                            *ngFor="let doc of dealDocs.dealer"
                            mat-button
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            [class.disabled]="isDocumentDisabled(doc)"
                            (click)="routeTo(doc)"
                            [attr.data-test]="'dealer-queue-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                            <div class="icons">
                                <p class="icon-D" *ngIf="doc.isDealerOnly" matTooltip="This document is only accessible by a Dealer">D</p>
                                <div class="doc-vert-wrap" [matMenuTriggerFor]="docActionsMenu" #menuTrigger="matMenuTrigger" (click)="preventClick($event)">
                                    <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                </div>
                                <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                    <div>
                                        <button mat-menu-item (click)="viewAuditTrail($event, doc); menuTrigger.closeMenu()" data-test="deals-close-deal">
                                            Audit Trail
                                        </button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button
                                            mat-menu-item
                                            [disabled]="doc.systemDocument"
                                            [matTooltip]="doc.systemDocument ? 'System Documents cannot be modified.' : ''"
                                            [class.disabled]="doc.systemDocument"
                                            (click)="openEditDocModal($event, doc); menuTrigger.closeMenu()"
                                        >
                                            Edit Document
                                        </button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button mat-menu-item class="delete" (click)="deleteDocument($event, doc); menuTrigger.closeMenu()">
                                            Delete Document
                                        </button>
                                    </div>
                                </mat-menu>
                            </div>
                        </button>
                    </div>
                </ng-container>
                <ng-template #noDealerDocs>
                    <p class="no-docs" data-test="deals-dealer-queue-no-docs">No documents found.</p>
                </ng-template>
            </div>

            <!-- BUYER -->
            <div class="card" data-test="deals-buyer-queue-card">
                <h2 data-test="deals-buyer-queue-card-title">
                    <span>Documents Waiting For Buyer ({{ dealDocs.buyer.length }})</span>

                    <span
                        matTooltip="Sorry, this user has not logged in to the system yet.
                    Please click 'Send Welcome Message' under 'Buyer Information' and have the user setup their account."
                        [matTooltipDisabled]="canSendBuyerNotification"
                    >
                        <button
                            data-test="deals-buyer-queue-send-notification"
                            class="secondary small"
                            *ngIf="dealDocs.buyer.length > 0 && deal.statusId !== dealType.Archived"
                            mat-button
                            [disabled]="!canSendBuyerNotification"
                            (click)="sendNotification(1)"
                        >
                            Send Notification
                        </button>
                    </span>
                </h2>

                <ng-container *ngIf="dealDocs.buyer.length > 0; else noBuyerDocs">
                    <div class="document-container" [ngClass]="dealDocs.buyer.length <= 3 ? 'left' : 'center'" data-test="deals-buyer-queue-docs-list">
                        <button
                            *ngFor="let doc of dealDocs.buyer"
                            mat-button
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            [class.disabled]="isDocumentDisabled(doc)"
                            (click)="routeTo(doc)"
                            [attr.data-test]="'buyer-queue-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                            <div class="icons">
                                <p class="icon-D" *ngIf="doc.isDealerOnly" matTooltip="This document is only accessible by a Dealer">D</p>
                                <div class="doc-vert-wrap" [matMenuTriggerFor]="docActionsMenu" #menuTrigger="matMenuTrigger" (click)="preventClick($event)">
                                    <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                </div>
                                <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                    <div>
                                        <button mat-menu-item (click)="viewAuditTrail($event, doc); menuTrigger.closeMenu()">Audit Trail</button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button
                                            mat-menu-item
                                            [disabled]="doc.systemDocument"
                                            [matTooltip]="doc.systemDocument ? 'System Documents cannot be modified.' : ''"
                                            [class.disabled]="doc.systemDocument"
                                            (click)="openEditDocModal($event, doc); menuTrigger.closeMenu()"
                                        >
                                            Edit Document
                                        </button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button mat-menu-item class="delete" (click)="deleteDocument($event, doc); menuTrigger.closeMenu()">
                                            Delete Document
                                        </button>
                                    </div>
                                </mat-menu>
                            </div>
                        </button>
                    </div>
                </ng-container>
                <ng-template #noBuyerDocs>
                    <p class="no-docs" data-test="deals-buyer-queue-no-docs">No documents found.</p>
                </ng-template>
            </div>

            <!-- COBUYER -->
            <ng-container *ngIf="hasCoBuyer || hasCoBuyerDocuments">
                <div class="card" data-test="deals-cobuyer-queue-card">
                    <h2 data-test="deals-cobuyer-queue-card-title">
                        <span>Documents Waiting For Co-Buyer ({{ dealDocs.cobuyer.length }})</span>

                        <span
                            matTooltip="Sorry, this user has not logged in to the system yet.
                        Please click 'Send Welcome Message' under 'Co-Buyer Information' and have the user setup their account."
                            [matTooltipDisabled]="canSendCoBuyerNotification"
                        >
                            <button
                                *ngIf="dealDocs.cobuyer.length > 0 && deal.statusId !== dealType.Archived"
                                mat-button
                                class="secondary small"
                                (click)="sendNotification(2)"
                                [disabled]="!canSendCoBuyerNotification"
                                data-test="deals-cobuyer-queue-send-notification"
                            >
                                Send Notification
                            </button>
                        </span>
                    </h2>

                    <ng-container *ngIf="dealDocs.cobuyer.length > 0; else noCobuyerDocs">
                        <div class="document-container" [ngClass]="dealDocs.cobuyer.length <= 3 ? 'left' : 'center'" data-test="deals-cobuyer-queue-docs-list">
                            <button
                                *ngFor="let doc of dealDocs.cobuyer"
                                mat-button
                                [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                                [class.disabled]="isDocumentDisabled(doc)"
                                (click)="routeTo(doc)"
                                [attr.data-test]="'cobuyer-queue-doc-' + doc.displayName"
                            >
                                <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                                <div class="icons">
                                    <p class="icon-D" *ngIf="doc.isDealerOnly" matTooltip="This document is only accessible by a Dealer">D</p>
                                    <div
                                        class="doc-vert-wrap"
                                        [matMenuTriggerFor]="docActionsMenu"
                                        #menuTrigger="matMenuTrigger"
                                        (click)="preventClick($event)"
                                    >
                                        <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                    </div>
                                    <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                        <div>
                                            <button mat-menu-item (click)="viewAuditTrail($event, doc); menuTrigger.closeMenu()" data-test="deals-close-deal">
                                                Audit Trail
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                *ngIf="deal.statusId !== DealStatus.Deleted"
                                                mat-menu-item
                                                [disabled]="doc.systemDocument"
                                                [matTooltip]="doc.systemDocument ? 'System Documents cannot be modified.' : ''"
                                                [class.disabled]="doc.systemDocument"
                                                (click)="openEditDocModal($event, doc); menuTrigger.closeMenu()"
                                            >
                                                Edit Document
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                *ngIf="deal.statusId !== DealStatus.Deleted"
                                                mat-menu-item
                                                class="delete"
                                                (click)="deleteDocument($event, doc); menuTrigger.closeMenu()"
                                            >
                                                Delete Document
                                            </button>
                                        </div>
                                    </mat-menu>
                                </div>
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #noCobuyerDocs>
                        <p class="no-docs" data-test="deals-cobuyer-queue-no-docs">No documents found.</p>
                    </ng-template>
                </div>
            </ng-container>

            <!-- APPLYING DIGITAL SIGNATURE -->
            <div class="card" *ngIf="dealDocs.signingCertInProcess.length > 0" data-test="deals-apply-digital-cert-card">
                <h2 data-test="deals-apply-digital-cert-card-title">
                    <span> Applying Digital Certificate ({{ dealDocs.signingCertInProcess.length }}) </span>
                </h2>

                <ng-container *ngIf="dealDocs.signingCertInProcess.length > 0">
                    <div
                        class="document-container"
                        [ngClass]="dealDocs.signingCertInProcess.length <= 3 ? 'left' : 'center'"
                        data-test="deals-apply-digital-certs-docs-list"
                    >
                        <button
                            *ngFor="let doc of dealDocs.signingCertInProcess"
                            mat-button
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            (click)="signingCertInProgressClick($event, doc)"
                            [attr.data-test]="'apply-digital-cert-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="helpMessageStatusEnqueueCertification">{{ doc.displayName }}</p>
                        </button>
                    </div>
                </ng-container>
            </div>

            <!-- INTERVENTION REQUIRED -->
            <div class="card" *ngIf="dealDocs.interventionRequired.length > 0" data-test="deals-intervention-required-card">
                <h2 data-test="deals-intervention-required-card-title">
                    <span> Intervention Required ({{ dealDocs.interventionRequired.length }}) </span>
                </h2>

                <ng-container *ngIf="dealDocs.interventionRequired.length > 0">
                    <div
                        class="document-container"
                        [ngClass]="dealDocs.interventionRequired.length <= 3 ? 'left' : 'center'"
                        data-test="deals-intervention-required-docs-list"
                    >
                        <button
                            *ngFor="let doc of dealDocs.interventionRequired"
                            mat-button
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            (click)="signingCertInProgressClick($event, doc)"
                            [attr.data-test]="'intervention-required-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="helpMessageStatusInterventionRequired">{{ doc.displayName }}</p>
                        </button>
                    </div>
                </ng-container>
            </div>
            <!--NOTARIZE QUEUE-->
            <div *ngIf="dealDocs.notarizeQueue.length > 0" class="card" data-test="deals-completed-queue-card">
                <h2 data-test="deals-completed-queue-card-title">
                    <span>Notarize Queue ({{ dealDocs.notarizeQueue.length }})</span>
                    <span class="deal-buttons"> </span>
                </h2>

                <ng-container>
                    <div
                        class="document-container"
                        [ngClass]="dealDocs.notarizeQueue.length <= 3 ? 'left' : 'center'"
                        data-test="deals-completed-queue-docs-list"
                    >
                        <button
                            *ngFor="let doc of dealDocs.notarizeQueue"
                            mat-button
                            [class]="checkForAdditionalStyles(doc)"
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            (click)="routeTo(doc, DocActions.view)"
                            [attr.data-test]="'completed-queue-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                            <div class="icons">
                                <div class="doc-vert-wrap" [matMenuTriggerFor]="docActionsMenu" (click)="preventClick($event)">
                                    <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                </div>
                                <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                    <div *ngIf="canClose(true)">
                                        <div>
                                            <button mat-menu-item (click)="viewAuditTrail($event, doc)" data-test="deals-close-deal">Audit Trail</button>
                                        </div>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button mat-menu-item class="delete" (click)="deleteDocument($event, doc)">Delete Document</button>
                                    </div>
                                </mat-menu>
                            </div>
                        </button>
                    </div>
                </ng-container>
            </div>
            <!--NOTARIZE QUEUE END-->

            <!-- COMPLETED -->
            <div class="card" data-test="deals-completed-queue-card">
                <h2 data-test="deals-completed-queue-card-title">
                    <span>Completed Documents ({{ dealDocs.complete.length }})</span>
                    <span class="deal-buttons"> </span>
                </h2>

                <ng-container *ngIf="dealDocs.complete.length > 0; else noCompleteDocs">
                    <div class="document-container" [ngClass]="dealDocs.complete.length <= 3 ? 'left' : 'center'" data-test="deals-completed-queue-docs-list">
                        <button
                            *ngFor="let doc of dealDocs.complete"
                            mat-button
                            [class]="checkForAdditionalStyles(doc)"
                            [class.primary]="(doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)"
                            (click)="routeTo(doc, DocActions.view)"
                            [attr.data-test]="'completed-queue-doc-' + doc.displayName"
                        >
                            <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                            <div class="icons">
                                <!-- <mat-icon *ngIf="isDocNotarized(doc)" matTooltip="Document Notarized">discount</mat-icon> -->
                                <div
                                    [class.custom-icon-notarize]="
                                        (doc.fileName && doc.readyForSignatures) || (isDocumentRouteOne(doc) && doc.readyForSignatures)
                                    "
                                    class="custom-icon-notarize-white"
                                    matTooltip="Document Notarized"
                                    *ngIf="doc.isNotarize"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="508.161" height="508.165" viewBox="0 0 508.161 508.165">
                                        <path
                                            id="Subtraction_90"
                                            data-name="Subtraction 90"
                                            d="M322.161,508.163h0l-68.079-39.307L186,508.163l-39.307-68.081H68.081V361.468L0,322.161l39.306-68.081L0,186l68.08-39.307V68.08h78.613L186,0l68.08,39.307L322.161,0,361.468,68.08h78.613v78.613L508.162,186l-39.306,68.081,39.306,68.081-68.081,39.307v78.613H361.468l-39.307,68.081ZM206.59,241.678h0l94.98,130.3v2.1h68.511v-239H301.57V266.366l-94.98-130.3v-.984h-68.51v239h68.51v-132.4h0v0h0Z"
                                            transform="translate(-0.001 0.001)"
                                            fill="#fff"
                                        />
                                    </svg>
                                </div>
                                <p class="icon-D" *ngIf="doc.isDealerOnly" matTooltip="This document is only accessible by a Dealer">D</p>
                                <div class="doc-vert-wrap" [matMenuTriggerFor]="docActionsMenu" #menuTrigger="matMenuTrigger" (click)="preventClick($event)">
                                    <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                </div>
                                <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                    <div>
                                        <button mat-menu-item (click)="viewAuditTrail($event, doc); menuTrigger.closeMenu()" data-test="deals-close-deal">
                                            Audit Trail
                                        </button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button
                                            mat-menu-item
                                            [disabled]="doc.systemDocument"
                                            [matTooltip]="doc.systemDocument ? 'System Documents cannot be modified.' : ''"
                                            [class.disabled]="doc.systemDocument"
                                            (click)="openEditDocModal($event, doc); menuTrigger.closeMenu()"
                                        >
                                            Edit Document
                                        </button>
                                    </div>
                                    <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                        <button mat-menu-item class="delete" (click)="deleteDocument($event, doc); menuTrigger.closeMenu()">
                                            Delete Document
                                        </button>
                                    </div>
                                </mat-menu>
                            </div>
                        </button>
                    </div>
                </ng-container>
                <ng-template #noCompleteDocs>
                    <p class="no-docs" data-test="deals-completed-queue-no-docs">No documents found.</p>
                </ng-template>
            </div>

            <!-- DELETED -->
            <mat-expansion-panel class="card mobile-edge" data-test="deals-deleted-queue-card">
                <mat-expansion-panel-header>
                    <h2 data-test="deals-deleted-queue-card-title">
                        <span>Deleted Documents ({{ dealDocs.deleted.length }})</span>
                    </h2>
                </mat-expansion-panel-header>

                <ng-template matExpansionPanelContent>
                    <ng-container *ngIf="dealDocs.deleted.length > 0; else noDeletedDocs">
                        <div class="document-container" [ngClass]="dealDocs.deleted.length <= 3 ? 'left' : 'center'" data-test="deals-deleted-queue-docs-list">
                            <button
                                *ngFor="let doc of dealDocs.deleted"
                                mat-button
                                class="deleted-doc"
                                (click)="!doc.fileName ? docNotViewable() : routeTo(doc, DocActions.view)"
                            >
                                <p [matTooltip]="doc.preamble || doc.fileName">{{ doc.displayName }}</p>
                                <div class="icons">
                                    <p class="icon-D" *ngIf="doc.isDealerOnly" matTooltip="This document is only accessible by a Dealer">D</p>
                                    <div
                                        class="doc-vert-wrap"
                                        [matMenuTriggerFor]="docActionsMenu"
                                        #menuTrigger="matMenuTrigger"
                                        (click)="preventClick($event)"
                                    >
                                        <mat-icon class="doc-vert-icon">more_vert</mat-icon>
                                    </div>
                                    <mat-menu #docActionsMenu="matMenu" class="menu-actions" data-test="deals-action-menu">
                                        <div>
                                            <button mat-menu-item (click)="viewAuditTrail($event, doc); menuTrigger.closeMenu()">Audit Trail</button>
                                        </div>
                                        <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                            <button
                                                mat-menu-item
                                                [disabled]="!doc.fileName"
                                                [matTooltip]="
                                                    !doc.fileName
                                                        ? 'Currently, no PDF or image has been uploaded to this slot, resulting in nothing to be viewed at the moment.'
                                                        : ''
                                                "
                                                [class.disabled]="doc.systemDocument"
                                                (click)="routeTo(doc, DocActions.view)"
                                            >
                                                View Document
                                            </button>
                                        </div>
                                        <div *ngIf="deal.statusId !== DealStatus.Deleted">
                                            <button mat-menu-item class="restore" (click)="restoreDocument($event, doc); menuTrigger.closeMenu()">
                                                Restore Document
                                            </button>
                                        </div>
                                    </mat-menu>
                                </div>
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #noDeletedDocs>
                        <p class="no-docs" data-test="deals-deleted-queue-no-docs">No documents found.</p>
                    </ng-template>
                </ng-template>
            </mat-expansion-panel>

            <!-- NOTES -->
            <mat-expansion-panel class="card" data-test="deals-notes-card">
                <mat-expansion-panel-header>
                    <h2 class="notes-section-header" data-test="deals-notes-card-title">
                        <span>
                            Notes
                            <mat-icon
                                class="deal-header-clipboard"
                                matTooltip="Audit Trail"
                                (click)="viewNotesAuditTrail($event)"
                                data-test="deal-notes-audit-trail-button"
                            >
                                content_paste
                            </mat-icon>
                        </span>
                    </h2>
                </mat-expansion-panel-header>

                <div class="notes-container">
                    <textarea class="form-control input" [disabled]="true">{{ this.deal.notes }}</textarea
                    ><span class="note-length">{{ this.deal.notes?.length ?? 0 }}/1000</span>
                    <button
                        mat-button
                        class="secondary small edit-notes-button"
                        (click)="this.canModifyNotes() ? openEditNotesModal($event) : undefined"
                        [disabled]="!this.canModifyNotes()"
                        type="button"
                    >
                        Edit Notes
                    </button>
                </div>
            </mat-expansion-panel>
        </div>

        <div class="width-mobile">
            <deal-info
                [deal]="deal"
                [buyerIdVerificationResults]="buyerIdVerificationResults"
                [cobuyerIdVerificationResults]="cobuyerIdVerificationResults"
                [dealDocs]="dealDocs"
                (onUserEdit)="getIdVerificationResults()"
                (onDealEdit)="refreshDeal($event)"
                (onSubmitReload)="reloadDocs()"
                (onShowIdVerificationResultsDocument)="showPdfViewModal(deal.dealId, $event)"
                [showSubmitForReviewForBuyer]="showSubmitForReviewForBuyer"
                [showSubmitForReviewForCoBuyer]="showSubmitForReviewForCoBuyer"
                [disableSubmitForReview]="disableSubmitForReview"
            >
            </deal-info>
            <div class="deal-buttons"></div>
        </div>
    </div>
</section>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
